import { FilterParams } from '@synergy/models';
import { FormattedMessage, useIntl } from 'react-intl';
import { PoolMultiSelect, SelectOption, useFilter } from '@synergy/components';

import { ImportChangeState } from '../models/import-change-state';
import { ImportDetailTabs } from '../models/import-detail-tabs';
import { getImportChangeStateTranslationId } from '../utils/get-import-change-state-translation-id';

interface ImportChangeStateFilterProps {
    selectedTab: ImportDetailTabs;
}

export const ImportChangeStateFilter = (props: ImportChangeStateFilterProps) => {
    // hooks
    const { filter, updateFilter, registerFilterMap } = useFilter();
    const intl = useIntl();

    // const
    const values = (filter.get(FilterParams.ChangeState) as string)?.split(',');

    const ImportChangeStateOptions: SelectOption[] = Object.keys(ImportChangeState).map(key => {
        return {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value: (ImportChangeState as any)[key],
            displayValue: intl.formatMessage({ id: getImportChangeStateTranslationId(key, props.selectedTab) }),
        };
    });

    const onSelected = (selectedValues: ImportChangeState[]) => {
        filter.delete(FilterParams.ChangeState);
        if (selectedValues.length > 0) {
            filter.set(FilterParams.ChangeState, selectedValues.join(','));
        }
        updateFilter(filter);
    };

    registerFilterMap(FilterParams.ChangeState, (value: unknown) => {
        if (typeof value !== 'string') {
            return '';
        }

        const keys = value.split(',');
        return ImportChangeStateOptions.filter(option => keys.includes(option.value))
            .sort()
            .map(option => option.displayValue)
            .join(', ');
    });

    return (
        <PoolMultiSelect
            displayEmpty={true}
            name="type"
            label={<FormattedMessage id="app.label.status" />}
            fullWidth={true}
            value={values}
            onValueChange={onSelected}
            options={ImportChangeStateOptions}
        />
    );
};
